import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { reactive, ref, computed, watchEffect } from 'vue';
import { PropType } from 'vue'
import tools from '@/tools'
import { useAppStore } from '@/store/app'

export default /*#__PURE__*/_defineComponent({
  __name: 'Department',
  props: {
  label: { type: String, default: '级联选择器' },
  rules: Array,
  value: [String, Number],
  disabled: { type: Boolean, default: false }
},
  emits: ['update:value'],
  setup(__props, { emit }) {

const props = __props

const store = useAppStore()

const options = ref([])

watchEffect(() => {

  if (store.tenant_id) {
    const data = {
      tenant_id: store.tenant_id
    }
    tools.request(`/component/select/department`, data, { method: 'POST', message: false }).then(res => options.value = res.result.data)
  }

})





const result = computed(() => {
  if (props.value && options.value.length > 0) {
    const pathData = tools.j4tools.getNodePath(options.value, props.value, { idKey: 'value', parentIdKey: 'parentid', childrenKey: "children" })
    if (pathData.length > 0) {
      return pathData.map((option: any) => option.label).join('/');
    }
  }
})

const visible = ref(false)
const onShow = () => {
  if (!props.disabled) {
    visible.value = true
  }
}

const data = ref('')

const onFinish = ({ selectedOptions }: any) => {
  // console.log(selectedOptions)
  // console.log(data.value)
  emit('update:value', data.value)
  visible.value = false
};


return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cascader = _resolveComponent("van-cascader")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_field, {
      modelValue: _unref(result),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(result) ? (result).value = $event : null)),
      "is-link": !props.disabled,
      readonly: "",
      label: __props.label,
      placeholder: __props.label,
      rules: __props.rules,
      disabled: props.disabled,
      onClick: onShow
    }, null, 8, ["modelValue", "is-link", "label", "placeholder", "rules", "disabled"]),
    _createVNode(_component_van_popup, {
      show: visible.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cascader, {
          modelValue: data.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data).value = $event)),
          title: __props.label,
          options: options.value,
          disabled: props.disabled,
          "field-names": { text: 'label', value: 'value', children: 'children' },
          onClose: _cache[2] || (_cache[2] = ($event: any) => (visible.value = false)),
          onFinish: onFinish
        }, null, 8, ["modelValue", "title", "options", "disabled"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})